import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import http from '../../../../shared/http'
import { TApi, TRoutes } from '../../../../shared/const'

import bild from '../../../../assets/schulung/start.webp'
import styles from './style.module.scss'

/**
 * Der Einstieg in die Schulung, oben im Handbuch.
 *
 * Warum genau dort und nicht als eigener Menüpunkt: Die Schulung ist die
 * Kurzfassung des Handbuchs zum Schuljahresstart. Wer im Menü einen zweiten
 * Eintrag daneben sieht, fragt sich, was der Unterschied ist — und was er statt
 * des anderen lesen soll.
 *
 * Die Karte sagt, ob die Schulung schon durch ist. Ein Einstieg, der immer
 * gleich aussieht, wird nach dem dritten Mal übersehen; einer, der „bestanden"
 * sagt, ist ein kleiner Anlass, die Kollegin danach zu fragen.
 */
export default function LaunchCard() {
	const [stand, setStand] = useState(null)

	useEffect(() => {
		// Still: Wenn der Stand nicht kommt, fehlt eine Zeile auf der Karte — das
		// ist kein Grund für eine rote Meldung über dem Handbuch.
		http.get(TApi.ADMIN_TRAINING, { disableToast: true })
			.then(({ data }) => setStand(data))
			.catch(() => setStand(null))
	}, [])

	const fertig = Boolean(stand?.completedAt)
	const angefangen = Boolean(stand?.startedAt) && !fertig

	return (
		<section className={styles.launch}>
			<img className={styles.launchImage} src={bild} alt="" />
			<div className={styles.launchText}>
				<h3>Onboarding 2026/27</h3>
				<p>
					Eine Präsentation zu den Neuerungen des Schuljahrs: was dazugekommen ist, wen es betrifft und worauf
					ihr achten müsst. Mit kurzen Fragen, drei Jokern und eurer Abschlusskarte im eigenen Profil. Etwa 10
					Minuten.
				</p>
				{fertig && (
					<span className={styles.launchState}>
						Abgeschlossen · {stand.level?.label} · {stand.score} von {stand.maxScore} richtig
					</span>
				)}
				{angefangen && (
					<span className={styles.launchState}>
						Angefangen · {stand.score} von {stand.maxScore} Fragen beantwortet
					</span>
				)}
			</div>
			<Link className={styles.launchBtn} to={TRoutes.TRAINING}>
				{fertig ? 'Noch einmal ansehen' : angefangen ? 'Weitermachen' : 'Onboarding starten'}
			</Link>
		</section>
	)
}
